// src/pages/LoadingPage.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import CircularProgress from "@mui/material/CircularProgress";

function LoadingPage() {
  const { oId, pId,role ,board} = useAuth();
    
  const navigate = useNavigate();

useEffect(() => {
  if (oId && role) {
    let delay = 1000; // default 1s

    if (navigator.connection) {
      const { effectiveType, downlink } = navigator.connection;

      if (effectiveType === "4g" && downlink > 5) {
        delay = 500; // very fast
      } else if (effectiveType === "3g") {
        delay = 1500; // medium
      } else if (effectiveType === "2g" || effectiveType === "slow-2g") {
        delay = 3000; // very slow
      }
    }

    const timer = setTimeout(() => {
      if (oId && pId && role === "PRINCIPAL") {
        // ✅ Principal condition (requires oId + pId + role)
        navigate("/PrincipalDashboard");
      } else if (oId && role === "SUPERADMIN") {
        // ✅ SuperAdmin condition (requires oId + role only)
        navigate("/SuperAdminDashboard");
      } else if (oId && role === "ORGANIZATION") {
        // ✅ Organization condition (requires oId + role only)
        navigate("/OrganizationDashboard");
      } else if (oId && pId && role === "ADMISSION_FEE") {
        // ✅ ADMISSION_FEE condition (requires oId + role only)
        navigate("/Admission_DashBoard");
      } 
       else if (oId && pId && role === "TRANSPORT") {
        // ✅ TRANSPORT condition (requires oId + role only)
        navigate("/TransportDashboard");
      } 
       else if (oId && pId && role === "HRBP") {
        // ✅ HRBP condition (requires oId + role only)
        navigate("/Dashboard");
      } 
      else {
        console.warn("Unknown role:", role);
      }
    }, delay);

    return () => clearTimeout(timer);
  }
}, [oId, pId, role, navigate]);


  return (
    <div
      style={{
        margin: "5% 1% 1% 1%",    
      }}
    >
          <div
     style={{
        width: "80vw",
        height: "85vh",         // full screen height
        display: "flex",
        justifyContent: "center", // horizontal center
        alignItems: "center",     // vertical center
        background: "transparent",
        flexDirection: "column",
      }}
    >


      <CircularProgress />
      <p style={{ marginTop: "16px", fontSize: "16px", textAlign: "center" }}>
        Loading Page...
      </p>
       </div>
    </div>
  );
}

export default LoadingPage;

